export const DEFAULT_TITLE = 'No title'
export const DEFAULT_DESCRIPTION = 'No description'
